import React from 'react';
import Icon from './icon';

export default function TeamAssistIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <rect fill="currentColor" height="6.15385" width="1.23077" x="7.38461" />
      <rect fill="currentColor" height="6.15385" width="1.23077" x="7.38461" y="9.84613" />
      <rect
        fill="currentColor"
        height="3.10039"
        transform="rotate(-45 10.7022 11.5286)"
        width="1.16843"
        x="10.7022"
        y="11.5286"
      />
      <rect
        fill="currentColor"
        height="3.12398"
        transform="rotate(-45 2.34314 3.21332)"
        width="1.23077"
        x="2.34314"
        y="3.21332"
      />
      <rect
        fill="currentColor"
        height="3.03325"
        transform="rotate(-135 3.21335 13.6569)"
        width="1.23077"
        x="3.21335"
        y="13.6569"
      />
      <rect
        fill="currentColor"
        height="3.07605"
        transform="rotate(-135 11.4817 5.38855)"
        width="1.23077"
        x="11.4817"
        y="5.38855"
      />
      <rect
        fill="currentColor"
        height="6.15385"
        transform="rotate(90 6.15384 7.38464)"
        width="1.23077"
        x="6.15384"
        y="7.38464"
      />
      <rect fill="currentColor" height="6.15385" transform="rotate(90 16 7.38464)" width="1.23077" x="16" y="7.38464" />
    </Icon>
  );
}
